// URL COMPONENTS
export const ASSET = 'asset/'
export const SEASON = 'season/'
export const CLIENT = 'client/'
export const USER = 'user/'
export const JOBS = 'job/'
export const SOIL = 'soil/'
export const SUPPLIES = 'supplies/'
export const HEFTY = 'hefty/'
export const RECOMMENDATION = 'recommendation/'
export const SOILSAMPLING = 'soilsampling/'
export const ENVIRONMENT = 'environment/'
export const ZONECALC = 'zonecalc/'
export const FERT = 'fertilizer/'

// URL COMPOSITIONS
export const HEF_RECOMMENDATION = HEFTY + RECOMMENDATION
export const HEF_SUPPLIES = HEFTY + SUPPLIES
export const HEF_CLIENT = HEFTY + CLIENT
export const SOIL_JOB = SOILSAMPLING + JOBS
export const ZON_FERTS = ZONECALC + FERT

// REQUEST WATCH ON ROUTES
export const ASSET_ROUTE_URLS = [ ENVIRONMENT, ASSET, SEASON ]
export const MAP_ROUTE_URLS = [ SOIL_JOB, ENVIRONMENT, ASSET, SEASON ]
export const ACCOUNT_ROUTE_URLS = [ USER, CLIENT, HEF_CLIENT ]
export const SOIL_JOBS_ROUTE_URLS = [ ENVIRONMENT, ASSET, SEASON, SOIL_JOB, USER, SOIL ]
export const RECOMMENDATIONS_ROUTE_URLS = [ HEF_RECOMMENDATION, ZON_FERTS ]
export const SUPPLIES_ROUTE_URLS = [ SUPPLIES, HEF_SUPPLIES ]
